module.exports = __webpack_public_path__ + "static/media/flight.efb33aa6.svg";